export const CompleteIcon = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.0337 2.85672C13.299 2.60213 13.7209 2.61097 13.9756 2.87623C14.2302 3.14159 14.2213 3.5634 13.9561 3.81813L7.25219 10.256L4.37445 7.49206L4.32762 7.44263C4.10889 7.18539 4.11607 6.79896 4.35494 6.55016C4.60972 6.28484 5.0315 6.27656 5.29684 6.5313L7.25154 8.40859L13.0337 2.85672Z" />
    <path d="M6.59985 1.40014C8.25416 1.17451 9.84822 1.57864 11.1436 2.42627L10.336 3.48901C9.31425 2.84591 8.06967 2.54419 6.77988 2.72011C3.86388 3.11782 1.82241 5.80411 2.22012 8.72011C2.61784 11.6361 5.30413 13.6776 8.22012 13.2799C11.1361 12.8821 13.1776 10.1959 12.7799 7.27986C12.7797 7.27857 12.7789 7.27737 12.7787 7.27608C13.1322 7.22288 13.6685 7.13443 14.0872 7.02146C14.0911 7.0476 14.0963 7.07358 14.0998 7.09983C14.597 10.7448 12.0451 14.1027 8.40015 14.5998C4.75516 15.097 1.3973 12.5451 0.900154 8.90014C0.403013 5.25514 2.95485 1.89728 6.59985 1.40014Z" />
  </svg>
);
